import { render, staticRenderFns } from "./CartImageComponent.vue?vue&type=template&id=1b59fc4d&scoped=true&"
import script from "./CartImageComponent.vue?vue&type=script&lang=js&"
export * from "./CartImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./CartImageComponent.vue?vue&type=style&index=0&id=1b59fc4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59fc4d",
  null
  
)

export default component.exports